import { Component } from '@angular/core';
import { ActionButtonComponent } from 'src/app/home-page/components/action-button/action-button.component';
import { IActionButtonData } from 'src/app/home-page/components/action-button/IActionButtonData.model';
import { NavigationService } from '@core/services/navigation.service';

@Component({
  selector: 'cgw-atp-banner-section',
  standalone: true,
  imports: [ActionButtonComponent],
  templateUrl: './atp-banner-section.component.html',
  styleUrl: './atp-banner-section.component.scss',
})
export class AtpBannerSectionComponent {
  constructor(private navigationService: NavigationService) {}
  public moreButton: IActionButtonData = {
    type: 'primary',
    title: 'Ver más',
    action: (param?) => {
      this.navigationService.navigate(['/armatupc']);
    },
  };
}
